var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.customer)?_c('div',{staticClass:"customer-greeting-container d-flex align-center font-size-14 text-capitalize"},[_c('cmg-sign-in-image'),_c('div',{staticClass:"customer-greeting ml-1",attrs:{"tabindex":"0","role":"heading","aria-level":"6"}},[_vm._v(_vm._s(_vm.customerName))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }